import { Flow_0_0_2, getFullItemTwo, getAllInfo, getSkills, getSubmissionData, getAppointmentTypes } from '@flexus/core';
import { CollapseActionPanel, setActionPanelItems } from '../../../app-shell-features';

import { forkJoin, of } from 'rxjs';
import { skipWhile, take, map, switchMap } from 'rxjs/operators';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import gql from 'graphql-tag';
import { environment } from 'apps/studio/src/environments/environment';
import { KVLHeading } from '@flexus/ui-elements';
import moment from 'moment';

export const SP_GLOBAL_62: Flow_0_0_2 = {
	id: '62',
	name: 'job_paused_sp',
	itemType: 'flow',
	actionPanel: instance => setActionPanelItems(instance, ['job-details', 'notes', 'documents']),
	onStateInit: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	onStateDestroy: inst => {
		inst.store.dispatch(new CollapseActionPanel());
	},
	header: {
		title: (store, bf) => {
			const client = environment.client;
			if (client !== 'pgg_sp') {
				return store.select(getFullItemTwo)?.pipe(
					map(itemTwo => {
						if (itemTwo) {
							if (itemTwo?.claim?.applicant && itemTwo?.claim?.loan_information) {
								return `Set New Appointment / Move to CIL : ${itemTwo?.claim?.loan_information?.mavenclaimnumber} - ${itemTwo?.claim?.applicant?.surname}`;
							} else {
								return 'Set New Appointment / Move to CIL';
							}
						}
					})
				);
			} else if (client === 'pgg_sp') {
				return store.select(getFullItemTwo)?.pipe(
					map(itemTwo => {
						if (itemTwo) {
							if (itemTwo?.claim?.applicant && itemTwo?.claim?.loan_information) {
								return `Set New Appointment : ${itemTwo?.claim?.loan_information?.voucher_key} - ${itemTwo?.claim?.applicant?.first_name}`;
							} else {
								return 'Set New Appointment';
							}
						}
					})
				);
			}
		},
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Set new appointment / Change to CIL'
		},
		viewRoles: {
			0: 'Job Paused'
		}
	},
	serverCalls: {
		skills: {
			serviceVariable: 'spService',
			functionName: 'getSkills',
			responseSlice: 'skills',
			errorMessage: 'No skills were found!'
		},
		keyValueListForCiL: {
			errorMessage: 'Cash-in-Lieu details could not be retrieved',
			directCall: (http, store, sq) => {
				return forkJoin([
					store.select(getFullItemTwo)?.pipe(
						skipWhile(x => !x),
						take(1),
						map(res => res as any)
					),
					store.select(getAllInfo)?.pipe(
						skipWhile(x => !x),
						take(1),
						map(res => res as any[])
					)
				])?.pipe(
					map(([job, allInfo]) => {
						const list = {
							'Claim Type': job?.claim?.type ?? '',
							'Client Name': job?.claim?.applicant ? job?.claim?.applicant?.first_name + ' ' + job?.claim?.applicant?.surname : '',
							'Contact number': job?.claim?.applicant ? job?.claim?.loan_information?.contactnumber : '',
							'Client Alternative no': job?.claim?.loan_information?.cellnumber ?? '',
							Address: job?.claim?.address ?? ''
						};
						return [list];
					})
				);
			}
		}
	},
	startNode: 'SetNewAppointmentNotification',
	nodes: {
		SetNewAppointmentNotification: {
			component: {
				children: [
					{
						component: 'FLXHeadingWithInstructionsComponent',
						inputs: {
							title: 'Set new appointment',
							instructions: ['Your team leader has paused the job.', 'Please contact and arrange a new appointment'],
							itemMargin: '0 0 35px 0'
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: {
							colouredHeading: new KVLHeading('Important Information', 'secondary'),
							data$: 'importantInfoKeyValues',
							color: 'secondary',
							itemMargin: '0 0 35px 0'
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: {
							heading: 'Claim Details',
							data$: 'claimDetailKeyValues',
							itemMargin: '0 0 35px 0'
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: {
							heading: 'On-site Details',
							data$: 'onsiteKeyValues',
							itemMargin: '0 0 35px 0'
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: {
							heading: 'Customer Details',
							data$: 'customerContactKeyValues',
							itemMargin: '0 0 35px 0'
						}
					}
				]
			},
			showTabs: true,
			name: 'Overview',
			initFormFields: (bf, item, instance, sq) => {
				// bf.addControl('new_state', new FormControl(''));
			},
			serverCalls: {
				importantInfoKeyValues: {
					errorMessage: '!',
					directCall: (http, store, sq, bf) => {
						return store
							.select(getFullItemTwo)
							.pipe(
								skipWhile(x => !x),
								take(1),
								map(res => res as any)
							)
							.pipe(
								map(itemTwo => {
									const importantinfo = {
										'Paused reason ': itemTwo?.job_information?.paused_reason ?? 'No reason was provided for pausing the job.'
									};
									return [importantinfo];
								})
							);
					}
				},
				claimDetailKeyValues: {
					errorMessage: 'Something went wrong claim details',
					directCall: (http, store, sq) => {
						return forkJoin([
							store.select(getFullItemTwo)?.pipe(
								skipWhile(itt => !itt),
								take(1),
								map(res => res as any)
							),
							store.select(getAllInfo)?.pipe(
								skipWhile(ai => !ai),
								take(1),
								map(res => res as any)
							)
						])?.pipe(
							map(([itemTwo, info]) => {
								const skillobj = info?.skills.find(el => el.id === itemTwo?.skill);
								const skill = skillobj?.name;
								const claimtype = info?.claim_types.find(cl => cl?.id === itemTwo?.claim?.claim_type).name;
								const claimdetaillist = {
									'Claim Type ': `${claimtype}` ?? '',
									'Skill required ': `${skill}` ?? '',
									'Address ': itemTwo?.address ?? '',
									'Appointment Date ': itemTwo?.office_use?.requestedappointmentdate ?? 'No appointment date set',
									'Appointment Time ': itemTwo?.office_use
										? `${itemTwo.office_use.appointment_type} ${itemTwo.office_use.requestedappointmenttime}`
										: 'Appointment time not retrieved'
								};
								return [claimdetaillist];
							})
						);
					}
				},
				onsiteKeyValues: {
					errorMessage: "Couldn' retrieve on-site info",
					directCall: (http, store) => {
						return store
							.select(getFullItemTwo)
							.pipe(
								skipWhile(itt => !itt),
								take(1),
								map(res => res as any)
							)
							.pipe(
								map(itemTwo => {
									const onsitelist = {
										'On site contact person ': itemTwo?.claim?.loan_information?.onsiteperson ?? 'Not retrieved',
										'Contact number ': itemTwo?.claim?.loan_information?.onsitecontact ?? 'On-site contact number not available',
										'Notes ': itemTwo?.claim?.loan_information?.whatmatters ?? 'What Matters Not Retrieved'
									};
									return [onsitelist];
								})
							);
					}
				},
				customerContactKeyValues: {
					errorMessage: 'Customer contact information could not be retrieved',
					directCall: (http, store, sq, bf) => {
						const client = environment?.client;
						return store
							.select(getFullItemTwo)
							.pipe(
								skipWhile(f => !f),
								take(1),
								map(res => res as any)
							)
							.pipe(
								map(itemTwo => {
									let customercontactlist;
									if (client === 'pgg_sp') {
										customercontactlist = {
											'Customer ': itemTwo?.claim?.applicant ? `${itemTwo?.claim?.applicant?.first_name} ${itemTwo?.claim?.applicant?.surname}` : 'Customer name not available',
											'Customer cell ': itemTwo?.claim?.applicant?.contact_number ?? 'Cellular number not on record'
										};
									} else {
										customercontactlist = {
											'Customer ': itemTwo?.claim?.applicant ? `${itemTwo?.claim?.applicant?.first_name} ${itemTwo?.claim?.applicant?.surname}` : 'Customer name not available',
											'Customer cell ': itemTwo?.claim?.loan_information?.cellnumber ?? 'Cellular number not on record',
											'Customer Alternative No': itemTwo?.claim?.loan_information?.contactnumber ?? 'Alternative number not on record'
										};
									}
									return [customercontactlist];
								})
							);
					}
				}
			},
			navs: [
				{
					text: 'Continue',
					nextNode: 'SetAppointment'
				}
			]
		},
		SetAppointment: {
			showTabs: true,
			name: 'Set Appointment',
			initFormFields: (bf, item, instance, sq) => {
				bf.addControl(
					'appointmentData',
					new UntypedFormGroup(
						{
							appointmentDatePicker: new UntypedFormControl(null, [Validators.required]),
							appointmentTime: new UntypedFormControl(null, [Validators.required]),
							appointmentTimePicker: new UntypedFormControl(null, [Validators.required]),
							appointmentdatetype: new UntypedFormControl(null, [Validators.required]),
							skill: new UntypedFormControl(null),
							skillcatagory: new UntypedFormControl(null)
						},
						[Validators.required]
					)
				);
				sq.queryStore(
					gql`
						{
							selectedContext {
								fullItemTwo {
									office_use {
										skill
										skillcatagory
									}
								}
							}
						}
					`
				)
					.pipe(
						skipWhile(res => !res || !res.skill || !res.skillcatagory),
						take(1)
					)
					.subscribe(({ skill, skillcatagory }) => {
						const apd = bf.getControl('appointmentData');
						if (apd) {
							apd.get('skill')?.patchValue(skill);
							apd.get('skillcatagory')?.patchValue(skillcatagory);
						}
					});
			},
			component: 'FLXJobAppointmentComponent',
			inputs: {
				minDate: new Date(),
				title: 'Set appointments',
				instructions: [' - placeholder - ']
			},
			serverCalls: {
				customer_details: {
					errorMessage: 'No customer details were found!',
					directCall: (http, store, sq) => {
						return sq
							.queryObject(
								gql`
									{
										fullItemTwo {
											claim {
												applicant {
													first_name
													surname
													contact_number
												}
												loan_information {
													contactnumber
													cellnumber
												}
											}
										}
									}
								`,
								store.select(getFullItemTwo)?.pipe(
									skipWhile(fi => !fi || !fi.state),
									take(1),
									map(res => ({ fullItemTwo: res }))
								)
							)
							.pipe(
								map((qdat: any) => {
									const client = environment.client;
									if (client !== 'pgg_sp') {
										return [
											{
												'Client Name': `${qdat.first_name} ${qdat.surname}`
											},
											{ 'Contact Number': `${qdat.contactnumber}` },
											{ 'Mobile Number': `${qdat.cellnumber}` }
										];
									} else {
										return [
											{
												'Client Name': `${qdat.first_name} ${qdat.surname}`
											},
											{ 'Contact Number': `${qdat.contact_number}` },
											{ 'Mobile Number': `${qdat.contact_number}` }
										];
									}
								})
							);
					}
				},
				onsite_details: {
					errorMessage: 'No onsite details could be found!',
					directCall: (http, store, sq, bf) => {
						return sq
							.queryObject(
								gql`
									{
										fullItemTwo {
											claim {
												loan_information {
													onsiteperson
													onsitecontact
												}
											}
										}
									}
								`,
								store.select(getFullItemTwo)?.pipe(
									skipWhile(f => !f),
									take(1),
									map(res => ({ fullItemTwo: res }))
								)
							)
							.pipe(
								map((queryData: any) => {
									return [{ 'Onsite Contact Name': `${queryData.onsiteperson}` }, { 'Onsite Contact Number': `${queryData.onsitecontact}` }];
								})
							);
					}
				},
				appointmentTypes: {
					serviceVariable: 'service',
					functionName: 'getAppointmentTypes',
					errorMessage: 'No Appointment Types could be found!'
				}
			},
			// checkValidityForFields: ['appointmentData'],
			navs: [
				{
					text: 'Change to cash-in-lieu',
					nextNode: 'RecommendCIL',
					location: 'center',
					color: 'default',
					serverFirst: true
				},
				{
					text: 'Set Appointment',
					color: 'primary',
					// linkType: 'submit',
					optIntoValidation: true,
					disableOnLoad: true,
					nextNode: 'SubmissionSuccess',
					serverFirst: true,
					serverCalls: {
						response: {
							errorMessage: 'The job could not be updated!',
							directCall: (http, store, sq, bf) => {
								return forkJoin([
									store.select(getFullItemTwo)?.pipe(
										skipWhile(x => !x),
										take(1)
									),
									store.select(getSubmissionData)?.pipe(
										skipWhile(x => !x),
										take(1)
									),
									store.select(getAppointmentTypes)?.pipe(
										skipWhile(x => !x),
										take(1)
									),
									store.select(getSkills)?.pipe(
										skipWhile(x => !x),
										take(1)
									)
								])?.pipe(
									map(([job, submissionData, appointmentTypes, skills]) => {
										const job_id = job?.id;
										const current_state = 62;
										const new_state = 35;
										const appointment = bf.bigForm.get('appointmentData')?.value;
										const date = moment(appointment.appointmentDatePicker);
										date.hour(submissionData.appointmentData.appointmentTimePicker.hour);
										date.minutes(submissionData.appointmentData.appointmentTimePicker.minutes);

										const date_formatted = date.format('YYYY-MM-DDTHH:mm:ss');
										const packet = {
											job_id: job_id,
											current_state: current_state,
											new_state: new_state,
											appointment: {
												range_start: date_formatted,
												appointment_type: submissionData.appointmentData.appointmentTime,
												reason: ''
											}
										};
										return packet;
									}),
									switchMap(data => {
										return http.post(`${environment.api_url}v1/job_action/update_job/`, data);
									})
								);
							}
						}
					}
				}
			]
		},

		RecommendCIL: {
			hideTabItem: true,
			component: {
				children: [
					{
						component: 'FLXHeadingWithInstructionsComponent',
						inputs: {
							title: 'Client has requested to be paid out in cash',
							instructions: ['No work was done. Invoice a call-out fee']
						}
					},
					{
						component: 'FLXKeyValueListComponent',
						inputs: { data$: 'keyValueListForCiL' }
					}
				]
			},
			navs: [
				{
					text: 'Continue',
					color: 'primary',
					linkType: 'portal',
					portalData: {
						type: 'modal',
						paramFunc: (instance, store, bf) => {
							(instance.type = 'info'), instance.setMessage(['Are you sure you want to move to CIL']);
							instance.navButtons = [
								{
									text: 'No!',
									color: 'default',
									linkType: 'nextNode',
									nextNode: 'SetAppointment'
								},
								{
									text: 'Yes, move to CIL',
									color: 'primary',
									linkType: 'submitThenNext',
									serverCalls: {
										response: {
											errorMessage: 'Job may not have been moved to CIL',
											directCall: (http, store, sq, bf) => {
												// bf.bigForm.get('new_state')?.patchValue(66);
												return store.select(getFullItemTwo).pipe(
													take(1),
													switchMap((data: any) => {
														const effected_jobs: number[] = data?.id;
														const cil_state = 72;
														const cildata = {
															effected_jobs: [effected_jobs],
															cil_state: cil_state
														};
														return http.post(`${environment.api_url}v1/job_action/move_to_cil/`, cildata);
													})
												);
											}
										}
									},
									nextNode: 'SubmissionSuccess'
								}
							];
						}
					}
				}
			]
		},
		SubmissionSuccess: {
			component: 'FLXSuccessTickComponent'
		}
	},
	bigFormToStoreMapper: {
		appointmentData: 'appointmentData',
		new_state: 'new_state'
	}
};
